import React from "react"
import Text from "@amzn/meridian/text";
import {TextProps} from "src/interfaces/props/CommonProps";

export class MiniText extends React.Component<TextProps> {

    constructor(props: TextProps) {
        super(props);
    }

    render() {
        return(
            <Text type="b200" breakWord={this.props.breakWord}> {this.props.text} </Text>
        );
    }
}

export default MiniText;
